import { bikesresponseFromApi, countBikesresponseFromApi} from '../interfaces/bikes'
//bikesOnlineResponseFromApi
import { per_page } from "../services/config"

export const getCountBikes = (title:string): Promise<countBikesresponseFromApi> => {
  return fetch(
    `https://bikeindex.org/api/v3/search/count?stolenness=proximity&distance=100&location=Berlin${title}`
  )
  .then((res) => res.json())
}

export const getBikes = (page: number, title: string, fromto: string): Promise<bikesresponseFromApi> => {
  return fetch(
    `https://bikeindex.org/api/v3/search?&per_page=${per_page}&page=${page}&stolenness=proximity&distance=100&location=Berlin${title}${fromto}`
  )
    .then((res) => res.json())
}